export default __webpack_public_path__ + "static/media/tick.5b853d68.svg";